import { googleAnalyticsIdFactory } from '@my-backoffice/app/shared/factories/google-analytics/google-analytics-id.factory';
import { GOOGLE_ANALYTICS_ID } from '@my-backoffice/app/shared/tokens/google-analytics-id.token';
import { WINDOW } from '@my-backoffice/app/shared/tokens/window.token';
import { FactoryProvider } from '@angular/core';

export const GOOGLE_ANALYTICS_ID_PROVIDER: FactoryProvider = {
  deps: [WINDOW],
  useFactory: googleAnalyticsIdFactory,
  provide: GOOGLE_ANALYTICS_ID,
};
